import React, { Component } from "react";
import { connect } from "react-redux";
import { setSideMenuSelectedItem } from "../../redux/actions";
import { bindActionCreators } from "redux";

class Splash extends Component {
  state = {
    pageTitle: "خوش آمدید",
    pageTag: "splash",
  };

  componentDidMount() {
    document.title = this.state.pageTitle;
    this.props.setSideMenuSelectedItem(this.state.pageTag);
  }

  render() {
    this.checkLogin();
    return (
      <div className="mx-auto fragment fragment-align-center text-center">
        <div className="mx-auto">
        
          <div>
            <div style={{width:20, height: 20, borderWidth: 2}} className="spinner-border text-info text-info mt-3" role="status">
              <span className="sr-only"/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  checkLogin() {
    setTimeout(
      function () {
        if (this.props.login.isLogin === "true") {
          this.goToHome();
        } else {
          this.goToAuthentication();
        }
      }.bind(this),
      1000
    );
  }

  goToAuthentication() {
    this.props.history.push("/authenticationHome");
  }

  goToHome() {
    this.props.history.push("/dashboard");
  }
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Splash);

